import React, { useState } from 'react'
import s from './FeatureTeaser.module.css'
import { useTranslations } from 'next-intl'
import { Swiper, SwiperSlide, useSwiper } from 'swiper/react'

// Import Swiper styles
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

import { Navigation, Pagination, Mousewheel, Keyboard } from 'swiper/modules'
import FeatureTeaserItem, { IFeatureTeaserItem } from './FeatureTeaserItem'
import { showHtml } from '@lib/utils/utils'


export interface FeatureTeaserProps {
  title?: string
  subtitle?: string
  className?: string
  list?: Array<IFeatureTeaserItem>
}

const FeatureTeaser: React.FC<FeatureTeaserProps> = ((props) => {
  let {
    list,
    title,
    subtitle
  } = props

  const t = useTranslations('Cart')
  const [ showDetails, setShowDetails ] = useState(false);
  const [swiper, setSwiper] = useState(useSwiper());

  const onToggleDetailsClick = () => {
    setShowDetails(!showDetails);
  }


  return (
    <div className={`${s.root}`}>
      <div>
        <div className='px-space2 md:px-space10 lg:px-space12 xl:px-space16 py-space8 md:py-space20'>
          <div className={'h-full w-full relative'}>
            <div className={`${s.innerWrapper}`}>
              <div className={'px-space4 md:px-0'}>
                <h3 className={`${s.title} whitespace-pre max-w-p90 md:max-w-full`} dangerouslySetInnerHTML={showHtml(title ?? '')}></h3>
                <h4 className={`${s.subtitle} whitespace-pre pb-space8 md:pb-space12 max-w-e320 md:max-w-full md:pb-space16`} dangerouslySetInnerHTML={showHtml(subtitle ?? '')}></h4>
              </div>

              <div className={`${s.mobileFeatureWrapper} ${showDetails ? '' : `${s.detailsHidden} overflow-hidden`} w-full desktop:hidden`}>
                <Swiper
                  className='py-8'
                  slidesPerView={1.2}
                  centeredSlides={true}
                  spaceBetween={10}
                  cssMode={true}
                  navigation={{ nextEl: '#swiper-forward', prevEl: '#swiper-back' }}
                  pagination={{
                    clickable: true
                  }}
                  mousewheel={true}
                  keyboard={true}
                  scrollbar={{
                    draggable: true
                  }}
                  onSwiper={(s: any) => {
                    setSwiper(s)
                  }}
                  modules={[Navigation, Pagination, Mousewheel, Keyboard]}
                >
                  {list != null && (
                    list?.map((item, i) =>
                      <SwiperSlide key={`mobile-${i}`} className={`pb-10 ${s.autoHeight}`}>
                        <FeatureTeaserItem featureTeaserItem={item}></FeatureTeaserItem>
                      </SwiperSlide>
                    )
                  )}
                </Swiper>
              </div>


              <div className={`hidden desktop:grid ${showDetails ? '' : `${s.detailsHidden} overflow-hidden`} grid-cols-3 grid-cols-2 grid-cols-1 md:!grid-cols-${ list?.length ?? 0 > 0 ? list?.length : 1 } gap-8`}>
                {list != null && (
                  list?.map((item, i) => <FeatureTeaserItem key={`desktop-${i}`} featureTeaserItem={item}></FeatureTeaserItem>
                  )
                )}
              </div>

              <div className='flex justify-center mt-8'>
                <a
                  className='cursor-pointer text-neutral900 font-medium flex align-center'
                  onClick={onToggleDetailsClick}>
                  { showDetails && <>
                    <span>{t('seeLess')}</span>
                    <span className='ml-2 text-icon22 icon-22-CaretUp-22 self-center'></span>
                  </>}
                  { !showDetails && <>
                    <span>{t('seeMore')}</span>
                    <span className='ml-2 text-icon22 icon-22-CaretDown-22 self-center'></span>
                  </>}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
})

export default FeatureTeaser
